
import { Button } from "antd"
import { useEffect, useState } from "react"
import { URL_BACKEND, URL_REPORTE_INDIVIDUAL_ASPIRANTE } from "../../api/url"
import { sortDirections } from "../../data/datos"
import { esMatematicasCiencias } from "../../functions/arreglos"
import { elToast } from '../../functions/alertas';

const useReporteGeneral = ( pk_carrera ) => {

    // variables
    const [datosReporteAlumnos, setDatosReporteAlumnos] = useState([])
    const [data, setData] = useState([])
    const [textoBuscar, setTextoBuscar] = useState("")
    const [buscarInscrito, setBuscarInscrito] = useState("");
    const [buscarPendienteInscribir, setBuscarPendienteInscribir] = useState("");

    const [ loading, setLoading ] = useState( true )
    const [aspirantesPendientesInscribir, setAspirantesPendientesInscribir] = useState([])
    const [dataPendientesInscribir, setDataPendientesInscribir] = useState([])

    const [aspirantesInscritos, setAspirantesInscritos] = useState([]);
    const [dataAspirantesInscritos, setDataAspirantesInscritos] = useState([]);

    // para el filtrado por ciclos
    const [ciclosExamen, setCiclosExamen] = useState([])
    const [ciclo, setCiclo] = useState('todos')

    var mostrarMC, mostrarM, mostrarCarrera, columnas_filtradas;

    if ( pk_carrera !== 0 ) {
        mostrarMC = esMatematicasCiencias( pk_carrera )
        mostrarM = !esMatematicasCiencias( pk_carrera )
        mostrarCarrera = false
    } else {
        mostrarCarrera = true
        mostrarMC = true
        mostrarM = true
    }


    // funciones
    const traerDatosReporteAlumno = () => {

        let body = new FormData()
        body.append('funcion', 'reporteGeneralAlumnos')

        body.append('pk_carrera', pk_carrera)

        fetch( URL_BACKEND, {
            body,
            method: 'post'
        })
        .then( r => r.json() )
        .then(d => {
            setDatosReporteAlumnos( d )
            setData( d )
            setLoading( false )
        })
        // .catch(() => alert('Error en el servidor'))
    }

    const filtrar = ( cosaABuscar ) => {

        cosaABuscar = cosaABuscar.trim()

        if (cosaABuscar) {
            // aquí haremos una búsqueda porque el usuario escribió algo
            var resultadosNuevos = data.filter( function( elemento ){

                // console.log( elemento.nom_carrera );

                let busqueda = new RegExp( cosaABuscar, 'gi' )
                // if ( busqueda.test( elemento.nom_carrera ) || busqueda.test( elemento?.prematricula )  ) {
                if ( busqueda.test( elemento.nombre ) || busqueda.test( elemento?.prematricula )  ) {
                    return true
                } else {
                    return false
                }

            })
            setDatosReporteAlumnos( resultadosNuevos )

        } else {
            // aquí no haremos la búsqueda, pero devolvemos todos los elementos
            setDatosReporteAlumnos( data )
        }
    }


    const filtrarAspirantesInscritos = (cosaABuscar) => {

        cosaABuscar = cosaABuscar.trim()

        if (cosaABuscar) {
            // aquí haremos una búsqueda porque el usuario escribió algo
            var resultadosNuevos = dataAspirantesInscritos.filter( function( elemento ){

                let busqueda = new RegExp( cosaABuscar, 'gi' )
                if ( busqueda.test( elemento.nombre ) || busqueda.test( elemento.prematricula )  ) {
                    return true
                } else {
                    return false
                }

            })
            setAspirantesInscritos( resultadosNuevos )

        } else {
            // aquí no haremos la búsqueda, pero devolvemos todos los elementos
            setAspirantesInscritos( dataAspirantesInscritos )
        }

    }


    const filtrarAspirantesPendientesInscribir = (cosaABuscar) => {

        cosaABuscar = cosaABuscar.trim()

        if (cosaABuscar) {
            // aquí haremos una búsqueda porque el usuario escribió algo
            var resultadosNuevos = dataPendientesInscribir.filter( function( elemento ){

                let busqueda = new RegExp( cosaABuscar, 'gi' )
                if ( busqueda.test( elemento.nombre ) || busqueda.test( elemento.prematricula )  ) {
                    return true
                } else {
                    return false
                }

            })
            setAspirantesPendientesInscribir( resultadosNuevos )

        } else {
            // aquí no haremos la búsqueda, pero devolvemos todos los elementos
            setAspirantesPendientesInscribir( dataPendientesInscribir )
        }

    }


    const generarReporteIndividual = (datosAspirante) => {

        // console.log(datosAspirante);

        let formData = new FormData()
        formData.append("datosAspirante", JSON.stringify(datosAspirante));

        fetch(URL_REPORTE_INDIVIDUAL_ASPIRANTE, {
            method: 'post',
            body: formData
        })
        .then( res => res.blob() )
        .then(archivo => {

            let pdf = URL.createObjectURL(archivo);
            // window.open(pdf);

            let nombrePDF = "REPORTE INDIVIDUAL DE RESULTADOS - " + datosAspirante.nombre;

            var anchor = document.createElement("a");
            anchor.download = nombrePDF;
            anchor.href = pdf;
            anchor.click();

        })
        .catch(() => alert('Error en el servidor'))

    }

    function inscribirAspirante( pk_aspirante, nombre ) {

        if(!window.confirm("¿Estás seguro de inscribir a " + nombre + "?")) return;

        let body = new FormData()
        body.append( 'funcion', 'inscribirAspirante' )
        body.append( 'pk_aspirante', pk_aspirante )

        fetch( URL_BACKEND, {
            body,
            method: 'post'
        })
        .then( r => r.json() )
        .then( d => {

            if(d.codigo == true ){

                elToast('Aspirante inscrito con éxito.');
                traerAspirantesPendientesInscribir(); //recargar la tabla pendientes
                traerAspirantesInscritos(); //recargar tabla aspirantes inscritos

            }else{

                elToast('Ocurrió un error al inscribir aspirante.', 'error');

            }

        })

    }

    function traerAspirantesPendientesInscribir() {

        let body = new FormData()
        body.append( 'funcion', 'traerAspirantesPendientesInscribir' )

        fetch( URL_BACKEND, {
            body,
            method: 'post'
        })
        .then( r => r.json() )
        .then( (r) => {
            setAspirantesPendientesInscribir(r);
            setDataPendientesInscribir(r);
        } )
    }

    function traerAspirantesInscritos() {

        let body = new FormData();
        body.append("funcion", "traerAspirantesInscritos");
        body.append("ciclos", ciclo);
        fetch(URL_BACKEND, {
            body,
            method: "post",
        })
        .then((r) => r.json())
        .then((r) => {
            setAspirantesInscritos(r);
            setDataAspirantesInscritos(r);
        });

    }

    const traerCiclosExamen = () => {

        let datos = new FormData()
        datos.append('funcion', 'traerCiclosExamen');

        fetch( URL_BACKEND, {
            method: 'post',
            body: datos
        })
        .then( res => res.json() )
        .then( setCiclosExamen )
    }



    // useEffect
    useEffect(() => {
        traerDatosReporteAlumno()
        traerAspirantesPendientesInscribir()
        traerAspirantesInscritos()
        traerCiclosExamen()
    }, [])

    useEffect(() => {

        filtrar( textoBuscar )

    }, [ textoBuscar ])

    useEffect(() => {
        filtrarAspirantesInscritos(buscarInscrito)
    }, [buscarInscrito])

    useEffect(() => {
        filtrarAspirantesPendientesInscribir(buscarPendienteInscribir)
    }, [buscarPendienteInscribir])

    useEffect(() => {
        traerAspirantesInscritos()
    }, [ciclo])



    // tabla
    const columns = [
        {
            title: 'Prematrícula',
            dataIndex: 'prematricula'
        },
        {
            title: 'Nombre',
            dataIndex: 'nombre',
            sorter: (a, b) => a.nombre.localeCompare(b.nombre),
            sortDirections
        },
        {
            title: 'Carrera',
            dataIndex: 'nom_carrera',
            sortDirections,
            mostrarCarrera,
            // filters: filters_carreras,
            // onFilter: (value, record) => record.nom_carrera.indexOf(value) === 0,
        },
        {
            title: 'Expresión oral y escrita',
            dataIndex: 'pk_aspirante',
            render: (text, record) => {
                return ( <>{record.cantidad_correctas_eoye} / {record.total_eoye}</> )
                // return ( <Tag color="red">
                //     {record.cantidad_correctas_eoye} / {record.total_eoye}
                // </Tag> )
            },
            align: 'center'
        },
        {
            title: 'Matemáticas ciencias',
            dataIndex: 'pk_aspirante',
            render: (text, record) => {


                const total = 50;

                if ( record.total_m == "No aplica" ) {

                    if ( record.cantidad_correctas_mc == 0 ) {
                        /* txt_m = "$k->cantidad_correctas_m / 50"; */

                        return ( <>No aplica</> )

                    } else {
                        /* txt_m = "$k->cantidad_correctas_mc / 50"; */

                        return ( <>{record.cantidad_correctas_mc} / {total}</> )

                    }

                } else {
                    /* txt_m = "$k->cantidad_correctas_m / 50"; */

                    return ( <>No aplica</> )

                }


            },
            align: 'center',
            mostrar: mostrarMC
        },
        {
            title: 'Matemáticas EA',
            dataIndex: 'pk_aspirante',
            render: (text, record) => {


                const total = 50;

                if ( record.total_m == "No aplica" ) {

                    if ( record.cantidad_correctas_mc == 0 ) {
                        /* txt_m = "$k->cantidad_correctas_m / 50"; */

                        return ( <>{record.cantidad_correctas_m} / {total}</> )

                    } else {
                        /* txt_m = "$k->cantidad_correctas_mc / 50"; */

                        return ( <>No aplica</> )

                    }

                } else {
                    /* txt_m = "$k->cantidad_correctas_m / 50"; */

                    return ( <>{record.cantidad_correctas_m} / {total}</> )

                }

            },
            align: 'center',
            mostrar: mostrarM
        },
        {
            title: 'Inglés',
            dataIndex: 'pk_aspirante',
            render: (text, record) => {
                return ( <>{record.cantidad_correctas_i} / {record.total_i}</> )
                // return ( <Tag color="blue">
                //     {record.cantidad_correctas_i} / {record.total_i}
                // </Tag> )
            },
            align: 'center'
        },
        {
            title: 'Acciones',
            dataIndex: 'pk_aspirante',
            render: (text, record) => {

                let datosAspirante = {
                    "pk_aspirante": record.pk_aspirante,
                    "nombre": record.nombre,
                    "nom_carrera": record.nom_carrera,
                    "prematricula": record.prematricula,
                    "cantidad_correctas_eoye": record.cantidad_correctas_eoye,
                    "total_eoye": record.total_eoye,
                    "cantidad_correctas_i": record.cantidad_correctas_i,
                    "total_i": record.total_i,
                    "cantidad_correctas_m": record.cantidad_correctas_m,
                    "total_m": record.total_m,
                    "cantidad_correctas_mc": record.cantidad_correctas_mc,
                    "total_mc": record.total_mc
                }

                return (

                    <Button type="primary" onClick={ () => { generarReporteIndividual(datosAspirante) } }>Reporte individual</Button>

                )

            },
            align: 'center'
        },
        {
            title: 'Inscribir',
            dataIndex: 'pk_aspirante',
            render: (text, record) => <Button type="primary" onClick={ () => inscribirAspirante( text, record.nombre ) }>Inscribir</Button>,
            align: 'center'
        }
    ];

    // hola :D en estos siguientes 2 bloques de código estoy haciendo que se filtren 2 cosas
    // primero necesito las columnas que no estén ocultas ( depende de la materia del alumno )
    // luego filtro para saber si mostrar o no el campo de carrera
    columnas_filtradas = columns.filter(item => {
        if ( item.mostrar !== false ) {
            return item
        }
    })

    columnas_filtradas = columnas_filtradas.filter(item => {
        if ( item.mostrarCarrera !== false ) {
            return item
        }
    })



    return {
        datosReporteAlumnos,
        aspirantesPendientesInscribir,
        aspirantesInscritos,
        loading,
        columns: columnas_filtradas,
        setTextoBuscar,
        textoBuscar,
        setBuscarInscrito,
        buscarInscrito,
        setBuscarPendienteInscribir,
        buscarPendienteInscribir,
        // actualización
        ciclo, setCiclo,
        ciclosExamen
    }
}

export default useReporteGeneral
